import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import Modal from 'react-modal';

import AppProvider from './hooks';
import { cookies } from './services/session';
import Routes from './routes';
import GlobalStyles from './styles/global';

// Accessibility reasons
Modal.setAppElement('#root');

function App() {
  return (
    <CookiesProvider cookies={cookies}>
      <AppProvider>
        <BrowserRouter>
          <GlobalStyles />
          <Routes />
        </BrowserRouter>
      </AppProvider>
    </CookiesProvider>
  );
}

export default App;
